import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();
const SUPPORTED_LANGUAGES = ["es", "en"];

function normalizeLanguage(lang) {
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : "es";
}

function getUrlLanguage() {
  if (typeof window === "undefined") return "";

  const urlLang = new URLSearchParams(window.location.search).get("lang");
  return SUPPORTED_LANGUAGES.includes(urlLang) ? urlLang : "";
}

// El idioma depende solo de la URL: sin ?lang= (o con un valor no soportado) es español.
function getInitialLanguage() {
  return getUrlLanguage() || "es";
}

function syncUrlLanguage(lang) {
  if (typeof window === "undefined") return;

  const nextLang = normalizeLanguage(lang);
  const url = new URL(window.location.href);
  const currentLang = url.searchParams.get("lang");

  if (nextLang === "es") {
    if (!currentLang) return;
    url.searchParams.delete("lang");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    return;
  }

  if (currentLang === nextLang) return;

  url.searchParams.set("lang", nextLang);
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLanguage);

  useEffect(() => {
    const handlePopState = () => {
      setLangState(getInitialLanguage());
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const changeLanguage = (newLang) => {
    const nextLang = normalizeLanguage(newLang);
    setLangState(nextLang);
    syncUrlLanguage(nextLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
